import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { GetMyPassengerResponse } from '../../types/auth.js'

import { apiClient } from '../../lib/client.js'
import { meKeys } from './keys.js'

export interface AddMyFidelityCardResponse {
  companyId: string
  id: string
  passengerId: string
  cardNumber: string
}

interface AddMyFidelityCardParams {
  companyId: string
  passengerId: string
  cardNumber: string
}

export const useAddMyFidelityCardMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ passengerId, ...data }: AddMyFidelityCardParams) => {
      const response = await apiClient.client.post<AddMyFidelityCardResponse>(
        `/me/passengers/${passengerId}/fidelity-cards`,
        data
      )
      return response.data
    },
    onError: () => {
      queryClient.invalidateQueries({ queryKey: meKeys.passengers })
    },
    onMutate: async ({ companyId, passengerId, cardNumber }) => {
      await queryClient.cancelQueries({ queryKey: meKeys.passengers })

      const previousPassengers = queryClient.getQueryData<GetMyPassengerResponse[]>(
        meKeys.passengers
      )

      if (previousPassengers) {
        queryClient.setQueryData<GetMyPassengerResponse[]>(
          meKeys.passengers,
          previousPassengers.map((p) =>
            p.id === passengerId
              ? {
                  ...p,
                  fidelityCards: [
                    ...p.fidelityCards,
                    {
                      companyId,
                      companyName: '',
                      id: `temp-${Date.now()}`,
                      cardNumber,
                      iataCode: '',
                    },
                  ],
                }
              : p
          )
        )
      }

      return { previousPassengers }
    },
  })
}
